
/**
 * px 값을 rem으로 변환합니다.
 * @param px - 변환할 픽셀 값
 * @param base - 기준 폰트 사이즈 (기본값: 16)
 * @returns rem 문자열 (예: '2.5rem')
 */
export function pxToRem(px: number, base: number = 16): string {
  const remValue = px / base;
  //console.log(`[pxToRem] input: ${px}px, base: ${base}, result: ${remValue}rem`);
  return `${remValue}rem`;
}

/**
 * px (string 또는 number)를 rem 문자열로 변환하는 함수
 * @param px - '40px' 또는 40 형식의 값
 * @param base - 기준 폰트 사이즈 (기본값: 16)
 * @returns 변환된 rem 문자열 (예: '2.5rem')
 */
function pxStringToRem(px: string | number, base: number = 16): string {
  const pxValue =
    typeof px === 'string' ? parseFloat(px.replace('px', '')) : px;

  if (isNaN(pxValue)) {
    throw new Error(`Invalid px value: ${px}`);
  }

  return `${pxValue / base}rem`;
}
